/**
 * @description: 主题菜单歌曲自定义设置
 * @author: hwx
 * @update: lyr
 */
<template>
	<div class="theme-menu-wrap">
		<div class="tms-list" v-show="showList">
            <h1>主题菜单歌曲自定义设置</h1>
            <p>注：1、启用后，触摸屏点歌页面对应的分类列表将优先显示自定义的列表<br />2、启用成功后，需重启两次包厢机顶盒后生效</p>
            <el-form :inline="true" :model="list_form">
				<el-form-item label="门店">
					<el-select v-model="list_form.shop_id" filterable placeholder="请选择门店">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="pull-right">
					<el-button type="primary" @click="listQuery">查询</el-button>
				</el-form-item>
			</el-form>
            <el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="list_table">
				<el-table-column prop="shop_name" label="门店"></el-table-column>
				<el-table-column prop="name" label="类型名称"></el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						{{ scope.row.status == '1' ? '启用' : '禁用' }}
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
                        <span class="text-blue" @click="tmsStatus(scope.row.id, '-1', '禁用')" v-if="scope.row.status == '1'">禁用</span>
						<span class="text-blue" @click="tmsStatus(scope.row.id, '1', '启用')" v-else>启用</span>
						<span class="text-blue" @click="goSeledSong(scope.row.id, scope.row.name)">自定义列表</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="list_page"
				:total="list_total"
				@current-change="getListTable">
			</el-pagination>
        </div>
		<div class="tms-seled" v-show="showSeled">
			<div class="page-tit">{{seled_name}}</div>
			<p>注：1 删除或者更新排序后，需要重启两次包厢机顶盒后生效<br />2 如果使用“导入歌曲列表”，则列表需要严格按照对应巨嗨曲库的歌曲名称以及歌星名才能正常导入<br />
            3 歌曲列表最多支持添加100首歌曲</p>
			<el-form :inline="true" :model="seled_form">
				<el-form-item label="歌曲名称">
					<el-input placeholder="请输入歌曲名称" v-model="seled_form.title"></el-input>
				</el-form-item>
				<el-form-item label="歌星姓名">
					<el-input placeholder="请输入歌星姓名" v-model="seled_form.player"></el-input>
				</el-form-item>
				<el-form-item class="pull-right">
					<el-button type="primary" @click="seledQuery">查询</el-button>
					<el-button type="primary" @click="backList">返回</el-button>
					<el-button type="primary" @click="seledImport">导入歌曲列表</el-button>
					<input type="file" @change="uploadXlsFile($event)" ref="xlsFile" id="xlsFile" class="input-file-hide el-button">
					<el-button type="primary" @click="goAllSong">添加歌曲</el-button>
					<el-button type="primary" @click="seledDel(seled_id_multi, '2')">批量删除</el-button>
				</el-form-item>
			</el-form>
			<el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="seled_table"
				@selection-change="getSeledRows">
				<el-table-column label="排序">
					<template slot-scope="scope">
						<el-input v-model="scope.row.display_order" placeholder="请修改排序号" @blur="seledOrder(scope.row.id, scope.row.display_order)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="歌曲名称"></el-table-column>
				<el-table-column prop="player" label="歌星姓名"></el-table-column>
				<el-table-column label="来源">
					<template slot-scope="scope">{{scope.row.source == 1 ? '平台' : '自定义'}}</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="seledDel(scope.row.id, '1')">删除</span>
					</template>
				</el-table-column>
				<el-table-column type="selection"></el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="seled_page"
				:total="seled_total"
				@current-change="getSeledTable">
			</el-pagination>
		</div>
		<div class="tms-songs" v-show="showSongs">
			<div class="page-tit">{{seled_name}}</div>
			<el-form :inline="true" :model="songs_form">
				<el-form-item label="歌曲名称">
					<el-input placeholder="请输入歌曲名称" v-model="songs_form.name"></el-input>
				</el-form-item>
				<el-form-item label="歌星姓名">
					<el-input placeholder="请输入歌星姓名" v-model="songs_form.szPlayer"></el-input>
				</el-form-item>
				<el-form-item label="来源">
					<el-select placeholder="请选择歌曲来源" v-model="songs_source">
						<el-option label="平台" value="1"></el-option>
						<el-option label="自定义" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="pull-right">
					<el-button type="primary" @click="songsQuery">查询</el-button>
					<el-button type="primary" @click="backSeled">返回</el-button>
					<el-button type="primary" @click="songsAdd(songs_multi, '2')">批量添加</el-button>
				</el-form-item>
			</el-form>
			<el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="songs_table"
				@selection-change="getSongsRows">
				<el-table-column prop="szSong_name" label="歌曲名称"></el-table-column>
				<el-table-column prop="szPlayer" label="歌星姓名"></el-table-column>
				<el-table-column prop="songs_version" label="歌曲信息">
					<template slot-scope="scope">
						<span>{{scope.row.songs_version||'-'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="songsAdd(scope.row.szSong_code, '1')">添加</span>
					</template>
				</el-table-column>
				<el-table-column type="selection"></el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				v-show="songs_source=='1'"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="songs_page"
				:total="songs_total"
				@current-change="getSongsTable">
			</el-pagination>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				v-show="songs_source=='2'"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="songs_page"
				:total="songs_total"
				@current-change="getSongsTableByCustom">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				showList: true,
				showSeled: false,
				showSongs: false,
                loading: false,
                shop_list: [],

				list_form: {
					shop_id: ''
				},
				list_page: 1,
				list_total: 0,
				list_table: [],

				seled_form: {
					title: '',
					player: ''
				},
				seled_id: '',
				seled_name: '',
				seled_order: '',
				seled_page: 1,
				seled_total: 0,
				seled_table: [],
				seled_id_multi: [],

				songs_form: {
					name: '',
					szPlayer: ''
				},
				songs_source: '1',
				songs_page: 1,
				songs_total: 0,
				songs_table: [],
				songs_multi: [],
			}
		},
        created: function() {
			this.getShop();
		},
		mounted: function() {
			// this.getListTable(1);
		},
		methods: {
			// 获取门店数据
			getShop: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.shop_list.shift();
						_this.list_form.shop_id = _this.shop_list[0].id;
						_this.getListTable(1);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
            },

            // 列表
			getListTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('CustomSongs/getTypeList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"shop_id": _this.list_form.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total);
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			listQuery() {
				this.getListTable(1);
            },
            // 禁用、启用
            tmsStatus(id, status, name) {
                const _this = this;
				layer.confirm('确定'+ name +'？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('CustomSongs/upTypeStatus', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"id": id,
								"status": status
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.getListTable(_this.list_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
				});
			},
			// 自定义列表
			goSeledSong(id, name) {
				this.seled_id = id;
				this.seled_name = name;
				this.seled_form = {
					title: '',
					player: ''
				};
				this.getSeledTable(1);
				this.showList = false;
				this.showSeled = true;
			},
			getSeledTable(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('CustomSongs/getSongList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"songs_type_id": _this.seled_id,
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"title": _this.seled_form.title,
							"player": _this.seled_form.player
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.seled_total = Number(res.data.response.result.total);
						}
						_this.seled_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			seledQuery() {
				this.getSeledTable(1);
			},
			// 返回列表
			backList() {
				this.showList = true;
				this.showSeled = false;
			},
			// 修改排序
			seledOrder(id, display_order) {
				const _this = this;
				Vue.axios.post('CustomSongs/upDisplayOrder', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": id,
							"display_order": display_order
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('排序成功');
						_this.getSeledTable(_this.seled_page);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 获取选中行
			getSeledRows(val) {
				this.seled_id_multi = val;
			},
			// 删除歌曲
			seledDel(del_id, type) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					let ids = [];
					if(type === '1') {
						ids = [del_id];
					} else {
						del_id.forEach(v => {
							ids.push(v.id);
						});
					}
					Vue.axios.post('CustomSongs/delSongs', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"songs_type_id": _this.seled_id,
								"ids": ids
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getSeledTable(_this.seled_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
			},
			// 导入歌曲
			seledImport: function() {
				this.$refs.xlsFile.click();
			},
			// 上传
			uploadXlsFile: function(e) {
				const _this = this;

				let formData = new FormData();
				let obj = document.getElementById('xlsFile');
				formData.append("songsfile", obj.files[0]);
				// 清除file
				obj.value = '';

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"songs_type_id": _this.seled_id
						}
					},
					"comment": ""
				};
				Vue.axios.post("CustomSongs/importSongs?json=" + JSON.stringify(datas), formData, {
					transformRequest: [function (data, headers) {
						// 覆盖默认
						return data;
					}]
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('导入成功');
						_this.getSeledTable(_this.seled_page);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 跳转到全部歌曲列表页
			goAllSong: function() {
				this.songs_form = {
					name: '',
					szPlayer: ''
				};
				this.songs_page = 1
				this.songs_source = '1'
				this.getSongsTable(this.songs_page);
				this.showSeled = false;
				this.showSongs = true;
			},
			getSongsTable(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('PublicData/api_getSongsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"name": _this.songs_form.name,
							"szPlayer": _this.songs_form.szPlayer
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.songs_total = Number(res.data.response.data.total);
						}
						_this.songs_table = res.data.response.data.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			getSongsTableByCustom(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Songs/getCustomSongsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"szSong_name": _this.songs_form.name,
							"szPlayer": _this.songs_form.szPlayer
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.songs_total = Number(res.data.response.result.total);
						}
						_this.songs_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			songsQuery() {
				if (this.songs_source == '1') { // 平台
					this.getSongsTable(1);
				}else { // 自定义
					this.getSongsTableByCustom(1);
				}
			},
			// 返回自定义列表
			backSeled() {
				this.getSeledTable(this.seled_page);
				this.showSeled = true;
				this.showSongs = false;
			},
			// 获取选中行
			getSongsRows(val) {
				this.songs_multi = val;
			},
			// 添加歌曲
			songsAdd(songs, type) {
				const _this = this;
				let szSong_code = [];
				if(type === '1') {
					szSong_code = [songs];
				} else {
					songs.forEach(v => {
						szSong_code.push(v.szSong_code);
					});
				}

				if (_this.seled_total + szSong_code.length > 100) {
					layer.msg("最多支持添加100首")
					return
				}
				Vue.axios.post('CustomSongs/addSongs', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"songs_type_id": _this.seled_id,
							"szSong_code": szSong_code,
							"source": _this.songs_source
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('添加成功');
						if(type === '2') {
							if (_this.songs_source == '1') {
								_this.getSongsTable(_this.songs_page);
							}else {
								_this.getSongsTableByCustom(_this.songs_page);
							}
						}
						_this.getSeledTable(1); // 获取已选择的歌曲列表长度
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	p {
		line-height: 30px;
		color: #FF0707;
	}
</style>